exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".close-tab{opacity:0}.file-error-content-type p{color:#e91e63}.non-display{display:none!important}.accordion-caption{text-overflow:ellipsis;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded!./src/styles/css/nvabar.scss
// module id = 973
// module chunks = 0